// pt-PT source of truth for the onboarding area (submissions, detail,
// requests and new registration). English mirrors this in ../en/onboarding.ts.
export const onboarding = {
  submissions: {
    cards: {
      pendingReview: 'Por rever',
      changesRequested: 'Correções pedidas',
      pendingSistrade: 'Pendente SISTRADE',
      launched: 'Lançados',
      rejected: 'Rejeitados',
      total: 'Total',
    },
    title: 'Registos de onboarding',
    loading: 'A carregar…',
    countOne: '{n} registo',
    countOther: '{n} registos',
    searchPlaceholder: 'Pesquisar por nome, email ou departamento…',
    filter: 'Filtro: {label}',
    searchButton: 'Pesquisar',
    empty: 'Sem registos.',
    columns: {
      name: 'Nome',
      email: 'Email',
      department: 'Departamento',
      source: 'Origem',
      status: 'Estado',
      received: 'Recebido',
    },
  },

  detail: {
    loading: 'A carregar…',
    notFound: 'Registo não encontrado.',
    back: 'Voltar',
    edit: 'Editar',
    fields: {
      email: 'Email',
      phone: 'Telefone',
      jobTitle: 'Função',
      department: 'Departamento',
      researchGroup: 'Grupo de investigação',
      startDate: 'Data de início',
      source: 'Origem',
      requestedBy: 'Requisitado por',
      received: 'Recebido',
      reviewedBy: 'Revisto por',
      reviewNote: 'Nota de revisão',
      sistradeReference: 'Referência SISTRADE',
    },
    extraInfo: 'Informação adicional',
    notes: 'Notas',
    actions: 'Ações',
    notePlaceholder: 'Nota (obrigatória ao pedir correções, opcional nas restantes)…',
    approve: 'Aprovar',
    requestChanges: 'Pedir correções',
    reject: 'Rejeitar',
    requestChangesHint: 'Escreva a nota a enviar ao membro',
    launchHelp:
      'Depois de lançar os dados manualmente no SISTRADE, marque este registo como lançado. Pode registar a referência/ID do colaborador (opcional).',
    sistradeReferenceOptional: 'Referência SISTRADE (opcional)',
    markLaunched: 'Marcar como lançado no SISTRADE',
    editForm: {
      title: 'Editar dados',
      fullName: 'Nome completo',
      email: 'Email',
      phone: 'Telefone',
      startDate: 'Data de início',
      jobTitle: 'Função / cargo',
      department: 'Departamento',
      researchGroup: 'Grupo de investigação',
      notes: 'Notas',
      cancel: 'Cancelar',
      saving: 'A guardar…',
      save: 'Guardar',
    },
  },

  requests: {
    titleManager: 'Convites de registo',
    titleMine: 'Os meus pedidos',
    loading: 'A carregar…',
    countOne: '{n} convite',
    countOther: '{n} convites',
    newRegistration: 'Novo Registo',
    empty: 'Ainda não criou nenhum pedido de registo.',
    columns: {
      requester: 'Requisitante',
      recipient: 'Destinatário',
      method: 'Método',
      status: 'Estado',
      created: 'Criado',
      expires: 'Expira',
    },
    viewSubmission: 'Ver submissão',
    cancel: 'Cancelar',
  },

  new: {
    title: 'Novo Registo',
    subtitle: 'Convide ou registe uma nova pessoa no CIIMAR',
    choice: {
      prompt: 'Como pretende registar a nova pessoa?',
      emailTitle: 'Email',
      emailDesc: 'Inserir o email da pessoa; o sistema envia-lhe o link.',
      linkTitle: 'Link',
      linkDesc: 'Gerar um link para enviar você mesmo.',
      directTitle: 'Preencher agora',
      directDesc: 'Registo presencial: cria a ficha do colaborador diretamente.',
    },
    picker: {
      change: 'Alterar',
      placeholder: 'Procurar responsável por nome, código ou email…',
    },
    chooseAnother: 'Escolher outra opção',
    invite: {
      titleEmail: 'Registo por email',
      titleLink: 'Registo por link',
      createError: 'Não foi possível criar o convite.',
      emailLabel: 'Email da pessoa *',
      responsibleHelp:
        'Responsável (opcional) — quem acompanha a nova pessoa. Traz contexto útil (equipa/grupo) para o registo.',
      internalNote: 'Nota interna',
      submitting: 'A criar…',
      submitEmail: 'Enviar convite',
      submitLink: 'Gerar link',
      createdTitle: 'Convite criado',
      sentEmailPre: 'Enviámos o link de registo para ',
      sentEmailPost: '.',
      shareLink: 'Partilhe este link com a pessoa a registar:',
      codePre: 'Peça à pessoa para aceder a ',
      codePost: ' e introduzir este código:',
      copy: 'Copiar',
      copied: 'Copiado!',
      expiresNote: 'O convite fica associado a si e expira automaticamente.',
      createAnother: 'Criar outro registo',
    },
    direct: {
      title: 'Novo colaborador',
      help: 'Registo presencial: cria a ficha diretamente. O resto dos dados é preenchido na ficha do colaborador.',
      createError: 'Não foi possível criar o colaborador.',
      fullName: 'Nome completo *',
      professionalEmail: 'Email profissional',
      submitting: 'A criar…',
      submit: 'Criar e abrir ficha',
    },
  },
};
